import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcCall32IconOld } from '@gem/icons';
import { IconButton, IconViewSizes, PopoverMenu } from '@gem/ui-kit';

import { useStartCallButtonPresenter } from './StartCallButton.presenter';
import styles from './StartCallButton.styles.m.css';

interface IStartCallButtonProps {
  className?: string;
  groupId: string;
  startAudioCall: (() => unknown) | null;
  startVideoCall: (() => unknown) | null;
  startConferenceCall: (() => unknown) | null;
  scheduleCallEvent(): void;
}

export const StartCallButton: FC<IStartCallButtonProps> = observer((props) => {
  const {
    groupId,
    startAudioCall,
    startVideoCall,
    startConferenceCall,
    className,
    scheduleCallEvent,
  } = props;
  const { presenter, popover } = useStartCallButtonPresenter({
    groupId,
    startAudioCall,
    startVideoCall,
    startConferenceCall,
    scheduleCallEvent,
  });

  if (!presenter.menuItems.length) {
    return null;
  }

  return (
    <>
      <IconButton
        className={className}
        setRef={popover.containerRef}
        Icon={IcCall32IconOld}
        onClick={presenter.onClick}
        size={IconViewSizes.Big}
      />
      <PopoverMenu
        isOpened={popover.isOpened}
        placement="bottom-end"
        menuItems={presenter.menuItems}
        reference={popover.containerRef.current}
        className={styles.menu}
        onClose={popover.close}
      />
    </>
  );
});
